'use client';

import { type HTMLAttributes, type ReactNode } from 'react';

type CardFooterProps = HTMLAttributes<HTMLDivElement> & {
  children?: ReactNode;
};

export const CardFooter = ({ children, ...props }: CardFooterProps) => {
  return <div {...props}>{children}</div>;
};
